<template>
  <h3>Прочие потоки</h3>
  <div class="block">
    <p>Загрузка Прочих потоков является обязательной только для месячного и годового экспорта.</p>
    <p>При загрузке файлов по прочим потокам пользователь может проконсультироваться с загруженными данными в разделе «Денежные потоки». Если в файле «Прочие потоки» содержаться данные для нескольких когорт, то все когорты будут отображаться на интерфейсе.</p>
    <img src="@/assets/img/guide/other-cashflows-sidemenu.png" alt="" srcset="">
    <p>Далее представлена сводка таблиц для всех файлов «Прочие потоки», которые формируются на интерфейсе по прямому и исходящему бизнесу.</p>
    <table>
      <tr>
        <th colspan="2">Прямой бизнес</th>
      </tr>
      <tr>
        <td>Годовые Прочие потоки</td>
        <td>Месячные Прочие потоки</td>
      </tr>
      <tr>
        <td>ДП - валюта договора</td>
        <td>ДП по ООЧП (мес.) договор, текущий бизнес</td>
      </tr>
      <tr>
        <td>ДП - валюта отчетности</td>
        <td>ДП по ООЧП (мес.) отчетность, текущий бизнес</td>
      </tr>
      <tr>
        <td>Ставки дисконтирования</td>
        <td>ДП по ООЧП (мес.) договор, новый бизнес</td>
      </tr>
      <tr>
        <td></td>
        <td>ДП по ООЧП (мес.) отчетность, новый бизнес</td>
      </tr>
      <tr>
        <td></td>
        <td>Ставки дисконтирования</td>
      </tr>
      <tr>
        <td></td>
        <td>Данные в части ДЗ/КЗ на отчетную дату</td>
      </tr>
      <tr>
        <td></td>
        <td>Активы по непризнанным договорам на отчетную дату</td>
      </tr>
      <tr>
        <td></td>
        <td>Денежные потоки в валюте отчетности за период</td>
      </tr>
      <tr>
        <td></td>
        <td>Начисления выплат в валюте отчетности</td>
      </tr>
      <tr>
        <th colspan="2">Исходящий бизнес</th>
      </tr>
      <tr>
        <td>ДП - валюта договора</td>
        <td>ДП по ООЧП (мес.) договор, текущий бизнес</td>
      </tr>
      <tr>
        <td>ДП - валюта отчетности</td>
        <td>ДП по ООЧП (мес.) договор, новый бизнес</td>
      </tr>
      <tr>
        <td>Ставки дисконтирования</td>
        <td>ДП по ООЧП (мес.) отчетность, текущий бизнес</td>
      </tr>
      <tr>
        <td>Вероятности дефолта</td>
        <td>ДП по ООЧП (мес.) отчетность, новый бизнес</td>
      </tr>
      <tr>
        <td></td>
        <td>Ставки дисконтирования</td>
      </tr>
      <tr>
        <td></td>
        <td>Ставки дефолтов</td>
      </tr>
      <tr>
        <td></td>
        <td>Данные в части ДЗ/КЗ на отчетную дату</td>
      </tr>
      <tr>
        <td></td>
        <td>Активы по непризнанным договорам на отчетную дату</td>
      </tr>
      <tr>
        <td></td>
        <td>Денежные потоки в валюте отчетности за период</td>
      </tr>
      <tr>
        <td></td>
        <td>Фактические начисления ОВТ, вал.отчетности</td>
      </tr>
    </table>
  </div>
</template>
  
<script>
export default {
  name: 'OtherCashflows',
}
</script>

<style scoped>
h3{
  font-size: 32px;
  color: #0074b5;
}

h5{
  margin: 20px 0px;
  font-size: 24px;
  color: #0074b5;
}

.list{
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.list p{
  font-size: 16px;
}

table, th, td {
  color: #6b6f77;
  border: 1px solid black;
  border-collapse: collapse;

  margin: 20px 0px;
}

th{
  padding: 0px 10px;
}

td:nth-child(1){
  padding: 10px;
}

td:nth-child(2){
  padding: 10px 10px 10px 30px;
}

ul{
  display: flex;
  flex-direction: column;
  gap: 10px;

  margin: 20px 20px 20px 50px;
}

td ul{
  margin-left: unset;
}

ol{
  margin-left: 50px;
}

ol li{
  margin-top: 10px;
}

li p{
  margin-top: 10px;
}

ol li ul{
  margin-left: 50px;
}

p{
  margin-top: 10px;
  line-height: 20px;
}

img{
  max-width: 100%;
  margin: 50px 0px;
}
</style>
